import React from 'react';

import { Badge, StatusIndicator, cn } from '@column/ui';

import { Mode } from '../_util/RootEntityContext';

interface RootEntityModeBadgeProps {
  mode: Mode;
}

export const RootEntityModeBadge: React.FC<RootEntityModeBadgeProps> = ({ mode }) => {
  const isLive = mode === Mode.Live;
  return (
    <Badge
      variant="outline"
      className={cn(
        'gap-1 rounded-md px-2 py-0.5 leading-4',
        !isLive &&
          'border-orange-700/10 bg-orange-200/50 text-orange-600/80 dark:border-orange-400/20 dark:bg-orange-500/15 dark:text-orange-300'
      )}
    >
      <StatusIndicator mode={isLive ? 'live' : 'sandbox'} size="sm" className="-ml-0.5 shrink-0" />
      {isLive ? 'Live' : 'Sandbox'}
    </Badge>
  );
};
